import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

interface CollectionData {
    handle: string;
}

@Component
export class CollectionSlider extends ThemeComponent {

    @Ref() sliderWrapper!: HTMLDivElement;
    @Ref() navButtons!: HTMLButtonElement[];

    init() {

        for (const button of this.navButtons) {
            this.$listen(button, 'click', () => {

                const handle = String(button.getAttribute('data-collection-handle'));

                this.renderCollection(handle).catch((error) => {
                    throw Error(error.message);
                });

                for (const button of this.navButtons) {
                    button.classList.remove('tab-navigation__button--active');
                }

                button.classList.add('tab-navigation__button--active');


            });
        }


    }

    async renderCollection(handle: string) {
        try {

            await fetch(`/collections/${handle}?section_id=product-card-list`)
                .then((response) => response.text())
                .then((text) => {
                    this.sliderWrapper.innerHTML = text;
                }).catch((error) => {
                    if (typeof error === "string") {
                        throw Error(error);
                    } else if (error instanceof Error) {
                        throw Error(error.message);
                    }
                });

        } catch (error) {
            if (typeof error === "string") {
                throw Error(error);
            } else if (error instanceof Error) {
                throw Error(error.message);
            }
        }
    }

}
